"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Marketing = _interopRequireDefault(require("bender-url!../../img/Marketing.svg"));

var _Sales = _interopRequireDefault(require("bender-url!../../img/Sales.svg"));

var _Service = _interopRequireDefault(require("bender-url!../../img/Service.svg"));

var _CRM = _interopRequireDefault(require("bender-url!../../img/CRM.svg"));

var _CMS = _interopRequireDefault(require("bender-url!../../img/CMS.svg"));

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var _Hubs$HUB_MARKETING$H;

var _default = (_Hubs$HUB_MARKETING$H = {}, (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, _Hubs.default.HUB_MARKETING, _Marketing.default), (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, _Hubs.default.HUB_SALES, _Sales.default), (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, _Hubs.default.HUB_SERVICE, _Service.default), (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, _Hubs.default.HUB_CMS, _CMS.default), (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, "crm", _CRM.default), _Hubs$HUB_MARKETING$H);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/productPage/ProductPageIcons.js
// module id = 252
// module chunks = 5 6